/**
 * @Author: Junjie
 * @Date: 2022-09-21 21:54:46
 * @LastEditTime: 2022-09-21 21:56:52
 * @email: 781433561@qq.com
 * @Description: 动态规划求两个字符串的最大公共子串
 * @FilePath: /iplus-iwt-fe/src/utils/lcs.js
 **/
/**
 * longest common substring
 * @param str1 string字符串 the string
 * @param str2 string字符串 the string
 * @return string字符串
 */
 function LCS( str1 ,  str2 ) {
    let dp=[]
    let maxi,maxj
    let maxlen=0
    for(let i=0;i<str1.length+1;i++){
        dp[i]=[]
        for(let j=0;j<str2.length+1;j++){
            dp[i].push(0)
        }
    }
    for(let i=1;i<str1.length+1;i++){
        for(let j=1;j<str2.length+1;j++){
            if(str1[i-1]!=str2[j-1]){
                dp[i][j]=0
            }else{
                dp[i][j]=dp[i-1][j-1]+1;
                if(dp[i][j]>maxlen){
                    maxlen=dp[i][j]
                    maxi=i
                    maxj=j
                }
            }
        }
    }
    return str2.slice(maxj-maxlen,maxj)
    
}
module.exports = {
    LCS : LCS
};